export default __webpack_public_path__ + "static/media/home-icon.3eb36bc8.svg";